import {BaseContainerModel} from "../../../base-container.model";
import {
  bl_msg_channel_ext_RowClass,
  bl_msg_channel_hdr_RowClass,
  bl_msg_channel_hdr_RowInterface
} from "../../../../dbschema";

export class ChannelContainerModel extends BaseContainerModel{

  bl_msg_channel_hdr: bl_msg_channel_hdr_RowInterface = new bl_msg_channel_hdr_RowClass();
  bl_msg_channel_exts: bl_msg_channel_ext_RowClass[] = [];
}
